import {
  RecurrenceSchedule,
  RecurrenceScheduleDate
} from "@wingspanhq/wingspan-api-sdk";

export const selectorScheduleWithOccurrence = (request: {
  schedule?: RecurrenceSchedule;
  index: number;
  occurrence: Partial<RecurrenceScheduleDate>;
}): RecurrenceSchedule => ({
  ...request.schedule,
  scheduleDates: (request.schedule?.scheduleDates ?? []).map(
    (scheduleDate, index) =>
      index === request.index
        ? { ...scheduleDate, ...request.occurrence }
        : scheduleDate
  )
});
